import { omit } from 'lodash';
import { Methods, RestClient } from 'o2o_layout/lib/common/rest';
import { BIGDATA_CONSTANT } from '../../../../../common/constant';

const PlatformUserTermSearch = (criteria: any) => {
  const url_params = new URLSearchParams();

  if (criteria.page) criteria.page && url_params.append('page', (criteria.page - 1).toString());
  if (criteria.orderBy) criteria.orderBy && url_params.append('orderBy', criteria.orderBy.toString());
  if (criteria.pageSize) criteria.pageSize && url_params.append('pageSize', criteria.pageSize.toString());

  let url = BIGDATA_CONSTANT.url.account + `api/mngmnt/platform/config/search?${url_params.toString()}`;

  const payload = omit(criteria, ['orderBy', 'page', 'pageSize']);

  var restClient = new RestClient(Methods.POST, url);
  return new Promise((resolve, reject) => {
    restClient.execute({}, payload).then(
      (response: any) => {
        const user: any = response.data;
        resolve(user);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export default PlatformUserTermSearch;
